import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "./firebase";
export type RegisterAddress = { street: string; unit: string; city: string; state: string; zip: string };
export type AddressSuggestion = { id: string; label: string };
export type RegisterAddressContext = { funeralHomeId: string; slug: string; eventId: string };
const callable = httpsCallable<Record<string, string>, { suggestions?: AddressSuggestion[]; address?: RegisterAddress }>(getFunctions(firebaseApp, "us-east1"), "lookupPublicRegisterAddress");
export async function suggestRegisterAddress(context: RegisterAddressContext, query: string, sessionToken: string) {
  return (await callable({ ...context, action: "suggest", query, sessionToken })).data.suggestions || [];
}
export async function resolveRegisterAddress(context: RegisterAddressContext, placeId: string, sessionToken: string) {
  const address = (await callable({ ...context, action: "details", placeId, sessionToken })).data.address;
  if (!address) throw new Error("Address unavailable");
  return address;
}
